import * as React from "react";
import { createRoot } from "react-dom/client";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import App from "./components/main/App";

library.add(fas, far, fab);

const container = document.getElementById("body");
if (container) {
    const root = createRoot(container);
    root.render(<App />);
}
